import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { requireOrganizationData } from '../../helpers/dashboard';
import { isEqual, get } from 'lodash';
import { defaultState } from 'redux/ducks/Session';

export const EXPIRED_SESSION_ERROR_MESSAGE = 'Your session has expired. Please log in again.';

const PrivateRoute = ({ component: Component, element: Element, authenticated, session, ...rest }) => {
  const errorMessage = get(session, 'error.message', '');

  return (
    <Route
      {...rest}
      render={props => {
        if (!authenticated) {
          const returnUrl = encodeURIComponent(props.location.pathname + props.location.search);
          return <Redirect to={`/v2/login?returnUrl=${returnUrl}`} />;
        }

        if (isEqual(session, defaultState()) || errorMessage === EXPIRED_SESSION_ERROR_MESSAGE) {
          return (
            <Redirect
              to={{
                pathname: '/logout',
                state: {
                  from: 'sessionExpired',
                },
              }}
            />
          );
        }

        if (requireOrganizationData(rest.user, authenticated)) {
          return <Redirect to="/v2/create-event/organization" />;
        }

        if (Element) return Element(props);

        return <Component {...props} />;
      }}
    />
  );
};

const mapStateToProps = state => {
  return {
    session: state.session,
    authenticated: state.session.authenticated,
    user: state.session.currentUser,
  };
};

export default connect(mapStateToProps)(PrivateRoute);
